module.exports = __webpack_public_path__ + "img/sustainability.00f2d42b.svg";